<template>
  <div class="admin-users">
    <h2 class="page-title">用户管理</h2>

    <el-table :data="users" v-loading="loading" stripe>
      <el-table-column prop="username" label="用户名" />
      <el-table-column prop="nickname" label="昵称" />
      <el-table-column prop="email" label="邮箱" />
      <el-table-column label="角色" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_admin ? 'danger' : 'info'" size="mini">
            {{ scope.row.is_admin ? '管理员' : '普通用户' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="article_count" label="文章数" width="80" />
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="400px">
      <el-form :model="form" label-position="top">
        <el-form-item label="昵称">
          <el-input v-model="form.nickname" />
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.email" />
        </el-form-item>
        <el-form-item label="个人简介">
          <el-input v-model="form.bio" type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item label="重置密码（可选）">
          <el-input v-model="form.password" placeholder="输入新密码" type="password" show-password />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveUser">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { adminApi } from '../../utils/api'

export default {
  name: 'AdminUsers',
  data() {
    return {
      users: [],
      loading: false,
      dialogVisible: false,
      editId: null,
      form: { nickname: '', email: '', bio: '', password: '' }
    }
  },
  computed: {
    dialogTitle() { return '编辑用户' }
  },
  created() {
    this.loadUsers()
  },
  methods: {
    async loadUsers() {
      this.loading = true
      try {
        const res = await adminApi.getUsers()
        this.users = res.users || []
      } catch (e) { console.error(e) }
      this.loading = false
    },
    showEditDialog(row) {
      this.editId = row.id
      this.form = { nickname: row.nickname, email: row.email, bio: row.bio, password: '' }
      this.dialogVisible = true
    },
    async saveUser() {
      try {
        const data = { nickname: this.form.nickname, email: this.form.email, bio: this.form.bio }
        if (this.form.password) data.password = this.form.password
        await adminApi.updateUser(this.editId, data)
        this.$message.success('用户更新成功')
        this.dialogVisible = false
        this.loadUsers()
      } catch (e) {
        this.$message.error('操作失败')
      }
    }
  }
}
</script>

<style scoped>
.page-title {
  font-size: 22px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 16px;
}
</style>
